<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col-md-12">
          <h3 class="page-title">Change Password</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <div class="row">
      <div class="col-md-12">
        <div class="alert alert-danger">
          Password Requirement: Must be minimum of 6 characters with combination
          of upper and lower case letters, numbers, and non-alphanumeric symbols
        </div>
        <form @submit.prevent="savePassword">
          <div class="form-group">
            <label>Current Password<span class="text-danger">*</span></label>
            <input
              class="form-control"
              required
              type="password"
              v-model="currentPassword"
              maxlength="50"
              autocomplete="off"
            />
          </div>
          <div class="form-group">
            <label>New Password<span class="text-danger">*</span></label>
            <input
              class="form-control"
              required
              type="password"
              v-model="newPassword"
              maxlength="50"
              autocomplete="off"
            />
          </div>
          <div class="form-group">
            <label
              >Confirm New Password<span class="text-danger">*</span></label
            >
            <input
              class="form-control"
              required
              type="password"
              v-model="confirmNewPassword"
              maxlength="50"
              autocomplete="off"
            />
          </div>
          <div class="form-group row mt-4">
            <div class="col">
              <button class="btn btn-secondary" @click="$router.go(-1)">
                <i class="fa fa-reply mr-2"></i>Back
              </button>
            </div>
            <div class="col-auto float-right ml-auto">
              <button type="submit" class="btn btn-primary">
                Save Changes
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- /Form -->
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },
  methods: {
    savePassword() {
      if (this.newPassword !== this.confirmNewPassword) {
        this.$swal("Confirm New Password and New Password do not match", {
          icon: "error",
        });
        return;
      }
      let param = {
        Token: this.token,
        Password: this.currentPassword,
        NewPassword: this.newPassword,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to change the password?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          API.changePassword(param)
            .then((response) => {
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.currentPassword = "";
                this.newPassword = "";
                this.confirmNewPassword = "";
              }
            })
            .catch((error) => {
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Account/ChangePassword.vue